module.exports = __webpack_public_path__ + "img/icon-toilets.475eec05.svg";